import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbDatepickerConfig, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { GrievanceService } from 'src/app/shared/services/grievance.service';
import { IKeyValuePair } from 'src/app/_models/common/common';
import { IPaged } from 'src/app/_models/common/IPaged';

@Component({
  selector: 'app-grivance',
  templateUrl: './grivance.component.html',
  styleUrls: ['./grivance.component.css']
})
export class GrivanceComponent implements OnInit {
  private readonly PAGE_SIZE = 10;
  loading: boolean;
  userMasterId;
  fromMinDate;
  fromMaxDate;
  fromStartDate;
  toMinDate;
  toMaxDate;
  toStartDate;
  serviceRequestsForm: FormGroup;
  //iRetursubmission: IRetursubmission;
  Id;
  years: any[];
  returTypes: any[];
  fillingPeriods: any[];

  queryResult: IPaged = {
    pageNumber: 0,
    items: [],
    totalRows: 0,
    pageSize: this.PAGE_SIZE
  };

  query: any = {
    page: 1,
    pageSize: this.PAGE_SIZE,
    sort: 'Id',
    sortDir: 'Desc',
    refNo: ',',
    createdFrom: ',',
    createdTo: ',',
    isActive: ',',
    status: ',',
    isReturn85ER1: '0',
    userMasterId: '',
    retururl: 0,
    id: 0,
  };

  columns = [
    { title: 'Sr No.', key: 'id', isSortable: false },
    { title: 'Date', key: 'JobRefNo', isSortable: false },
    { title: 'Ref No', key: 'refNo', isSortable: false },
    { title: 'Query Type', key: 'submitedYear', isSortable: false },
    { title: 'Comments', key: 'fillingPeriod', isSortable: false },
    { title: 'Status', key: 'status', isSortable: false },
    {}
  ];

  ngOnInit(): void {
    this.bindDropDown();
  }
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private modalService: NgbModal,
    private commonService: CommonService,
    private grievanceService: GrievanceService,
    private fb: FormBuilder,
    private config: NgbDatepickerConfig,
    private toastrService: ToastrService,
    private authService: AuthService) {

    this.userMasterId = this.authService.currentUserId;

    this.route.queryParams
      .subscribe(params => {
        this.query.page = isNaN(params.page) ? 1 : params.page;
        this.query.sort = params.sort ? params.sort : 'Id';
        this.query.sortDir = params.sortDir ? params.sortDir : this.query.sortDir;
        this.query.refNo = params.refNo ? params.refNo : '';
        this.query.createdFrom = params.createdFrom ? params.createdFrom : '';
        this.query.createdTo = params.createdTo ? params.createdTo : '';
        this.query.isActive = params.isActive ? params.isActive : '';
        this.query.status = params.status ? params.status : '';
        this.query.isReturn85ER1 = params.isReturn85ER1 ? params.isReturn85ER1 : '0';
        this.query.employerId = params.userMasterId ? params.userMasterId : '';
        this.PopulateSubmitReports();
        //this.createubmissionForm();
      });
  }
  createubmissionForm() {
    this.serviceRequestsForm = this.fb.group({
      id: [0, ''],
      userMasterId: [this.userMasterId, Validators.required],
      // yearId: ['', Validators.required],
      serviceFieldId: ['', Validators.required],

    });
  }

  onViewGrievance(id, eve) {
    this.router.navigate(['/employee/grievance/view-grievance'], {
      queryParams: {
        id: id,
      }
    });
  }
  onAddGrivance() {
    this.router.navigate(['/employee/grievance/add-grievance'], {});
  }
  reason: any;
  onViewGrievanceRecallReason(submitreturnreason, reason, eve) {
    this.reason = reason;
    this.modalService.open(submitreturnreason, { size: 'lg', windowClass: 'fade' });
  }

  private PopulateSubmitReports() {
    this.grievanceService.getAll(this.query)
      .subscribe((response: IPaged) => {
        if (response) {
          this.queryResult = response;
        }
      });
  }

  bindDropDown() {
    this.commonService.getGrievanceTypes().subscribe((response: IKeyValuePair[]) => {
      if (response) {
        this.returTypes = response;
      }
    });
  }
  filter() {
    this.query.page = 1;
    this.router.navigate(['/employee/grievance'], {
      queryParams: this.query
    });
  }

  close() {
    this.modalService.dismissAll();
  }

  sortBy(columnName) {
    this.query.page = 1;
    if (this.query.sort === columnName) {
      this.query.sortOrder = (this.query.sortOrder == "1" ? "2" : "1");
    } else {
      this.query.sort = columnName;
      this.query.sortOrder = "1";
    }

    this.router.navigate(['/employee/submit-report-list'], {
      queryParams: this.query
    });
  }

  resetClick() {
    this.router.navigate(['/employee/grievance']);
    this.query.refNo = '';
    this.query.isActive = '';
    this.query.status = '';
    this.query.createdFrom = '';
    this.query.createdTo = '';
    this.query.isReturn85ER1 = '0';
  }

  onRecallGrievance(id, eve) {
    this.router.navigate(['/employee/grievance/add-grievance'],
      {
        queryParams: {
          id: id,
        }
      });
  }
}

